module.exports = __webpack_public_path__ + "static/media/report_arrRight.3c22ed37.svg";